<template>
<div v-bind="$attrs">
  <v-chip color="green lighten-4" style="padding: 0 0 0 12px;">
    <!-- Question -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" class="pr-2" color="green darken-3">mdi-toggle-switch</v-icon>
      </template>
      <span>{{ $t('enable-when') }}</span>
    </v-tooltip>
    {{ conceptName || item.question }}
    <span v-if="item.question" class="pl-2">(#{{ $filters.getShortId(idWithoutVersionSuffix(item.question)) }})</span>

    <!-- Operator -->
    <v-icon color="green darken-3" class="pl-2 pr-2">{{ this.$filters.getOperatorSymbol(item.operator) }}</v-icon>

    <!-- Value -->
   <StructuralConditionAnswer :item="item" />
  </v-chip>
</div>
</template>

<script>
import StructuralConditionAnswer from '@/components/Utilities/StructuralConditionAnswer'
export default {
  name: 'StructuralCondition',
  components: {
    StructuralConditionAnswer
  },
  props: {
    conceptName: {
      type: String,
      required: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    idWithoutVersionSuffix (str) {
      return str?.replace(/--[\d]*/, '') || str
    }
  }
}
</script>
